// @flow

import type { ApiHandler } from '../types/api';
import type { PaymentStatusResponse } from '../types/instantBankTransfer';
import { get } from './shared';

export const getStatus = get(
  `/:paymentId/experience/attempt/:attemptId/status`,
); /** : ApiHandler<PaymentStatusResponse> */
